import { newE2EPage } from '@stencil/core/testing';

describe('jackery-loading', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<jackery-loading></jackery-loading>');

    const element = await page.find('jackery-loading');
    expect(element).toHaveClass('hydrated');
  });
});
